// Because we need to access the map object from the LeafletMap context,

import { depotsSelectors } from '@/entities/depots'
import { planningShiftTablesSelector } from '@/entities/gridTables/selectors/planningShiftTablesSelector'
import { planningUnassignedTablesSelector } from '@/entities/gridTables/selectors/planningUnassignedTablesSelector'
import { planningShiftsSelectors } from '@/entities/schedules'
import { widgetWindowsSelector } from '@/entities/widgetWindows'
import { OperationsMapWidgetWindow } from '@/entities/widgetWindows/models/WidgetWindow'
import { useLeafletMapContext } from '@/shared/components/LeafletMap'
import { useAppSelector } from '@/shared/store'

import { useDrawDepots } from './libs/useDrawDepots'
import { useDrawRoutes } from './libs/useDrawRoutes'
import { useDrawShifts } from './libs/useDrawShifts'
import { useDrawUnassignedOrders } from './libs/useDrawUnassignedOrders'
import { useFlyToSelectedStop } from './libs/useFlyToSelectedStop'
import { useOperationMapContext } from './OperationsMapWidgetContext'

//   we need to create a child component that will handle the drawing of the depots and routes on the map.
export const PlanningMapWidgetControl: React.FC = () => {
  const { map } = useLeafletMapContext()
  const { widgetId } = useOperationMapContext()
  const mapWindowState = useAppSelector(state => widgetWindowsSelector.selectById(state, widgetId))
  
  const allShifts = useAppSelector(state => planningShiftsSelectors.selectAll(state))
  const activeGroupId = useAppSelector(state => state.userInterface.activeGroupId)
  const depots = useAppSelector((state) => depotsSelectors.selectAll(state)).filter((depot) => depot.groupId === activeGroupId)
  const lastSelectedStopId = useAppSelector(state => state.userInterface.lastSelectedStopId)

  // Get the selected shift ids from the widget window state
  const selectedShiftIds = (mapWindowState as OperationsMapWidgetWindow)?.shiftIds || []
  const relevantShifts = allShifts.filter((shift) => selectedShiftIds.includes(shift.id))
  const shiftTableEntities = useAppSelector(state => planningShiftTablesSelector.selectEntities(state))
  const relevantShiftTables = relevantShifts.map((shift) => shiftTableEntities[shift.id])

  // Get the selected unassigned scenario ids from the widget window state
  const selectedUnassignedScenarioIds = (mapWindowState as OperationsMapWidgetWindow)?.unassignedScheduleIds || []
  const unassignedTableEntities = useAppSelector(state => planningUnassignedTablesSelector.selectEntities(state))
  const relevantUnassignedTables = selectedUnassignedScenarioIds.map((scenarioId) => unassignedTableEntities[scenarioId])

  useDrawShifts({
    map,
    shiftTables: relevantShiftTables,
  })

  useDrawUnassignedOrders({
    map,
    unassignedTables: relevantUnassignedTables,
  })

  useDrawDepots({
    map,
    depots,
  })

  useDrawRoutes({
    map,
    selectedShiftIds,
    allShifts,
    currentScreen: 'planning',
  })

  // Side effect that will fly to the last selected stop or order
  useFlyToSelectedStop({
    map,
    stopId: lastSelectedStopId,
    shiftTables: relevantShiftTables,
    currentScreen: 'planning',
  })

  return null
}
